import { Zap } from 'lucide-react';
import { useState } from 'react';

interface TriggerInputProps {
  disabled: boolean;
  label?: string;
}

export const TriggerInput = ({ disabled, label }: TriggerInputProps) => {
  const [triggered, setTriggered] = useState(false);

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => {
        if (!disabled) setTriggered(true);
        setTimeout(() => setTriggered(false), 2000);
      }}
      className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-all ${
        triggered
          ? 'bg-green-500 text-white border-green-500'
          : 'bg-[#C0275E] text-white hover:bg-[#a01f4e]'
      } disabled:opacity-60 disabled:cursor-default`}
    >
      <Zap size={16} />
      {triggered ? 'Triggered!' : (label ?? 'Trigger Action')}
    </button>
  );
};
